//export const HTTPURL = 'http://13.200.114.252:4040/';
export const HTTPURL = 'https://demo-backend.kindlebit.com/';
//export const HTTPURL = 'http://localhost:4040/';